import { NavigationGuard } from 'vue-router';

const middlewares: NavigationGuard[] = [];

export default middlewares;
